module.exports = __webpack_public_path__ + "img/sarahbrennerkussmaul.7bf1d522.jpeg";